import { AlignmentType, BorderStyle, Document, Footer, Header, HeadingLevel, HeightRule, ImageRun, LevelFormat, Packer, PageNumber, Paragraph, SectionType, ShadingType, TabStopType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TextDirection, TextRun, VerticalAlign, WidthType, convertInchesToTwip } from "docx"
import { auditReportTableNetwork, reportAppNameNetwork } from "./Part1/NetworkAuditPage1"
import { saveAs } from "file-saver";
import { documentDistributionNetwork, documentHistoryNetwork, documentPreparationNetwork, page2HeadingNetwork } from "./Part1/NetworkAuditPage2";
import { introductionBulletOneNetwork, introductionText1Network } from "./Part1/NetworkAuditPage3";
import { introductionBulletThree, introductionBulletTwo } from "../../Web/CertInAuditSupport-Page/Part1Audit/Page4Audit";
import { scopeNetwork } from "./Part1/NetworkAuditPage4";
import { teamNetwork } from "../../Web/CertInAuditSupport-Page/Part1Audit/Page5Audit";
import { auditActivities, auditActivities1, timelines } from "../../Web/CertInAuditSupport-Page/Part2Audit/Page7Audit";
import { auditPoint1Network, auditPoint2Network, auditPoint3Network, timeline1Network } from "./Part1/NetworkAuditPage5";
import { Methodology, acclimatizePhase, accrualPhase, accrualPhaseText, admittancePhase, affirmationPhase, analysisPhase, analysisPhaseText } from "../../Web/CertInAuditSupport-Page/Part2Audit/Page8Audit";
import { acclimatizePhaseTextAudit1, acclimatizePhaseTextAudit2, acclimatizePhaseTextAudit3, acclimatizebullet1Audit, acclimatizebullet2Audit, acclimatizebullet3Audit, accrualPhasebullet1Audit, accrualPhasebullet2Audit, accrualPhasebullet3Audit, accrualPhasebullet4Audit, accrualPhasebullet5Audit, admittancePhaseTextAudit, affirmationPhaseTextAudit, methodologyAuditNote } from "./Part2/NetworkAuditPage6";
import { FrameworkAudit, frameworkAuditText, toolsAudit, toolsAuditTable } from "./Part2/NetworkAuditPage7";
import { severityAuditLevelTable, summaryAudit1, summaryAudit2, summaryGraph1, summaryGraph2, summaryGraphchart2, summaryNoteAudit, summaryNoteAudit2, summaryNotebullet1, summaryNotebullet2 } from "./Part2/NetworkAuditPage8";
import { observationAudit1, observationAudit2, observationAudit3 } from "./Part3/NetworkAuditPage9";
import { appendicesTableAudit, auditTools1, riskRatingAudit, riskRatingTableAudit } from "./Part3/NetworkAuditPage10";
import { TOCHeadingsNetwork } from "../NetworkInternalCertinReport/Part1/Page1Network";
import { url } from "../../../../constants/url";
import { toast } from "react-toastify";


export async function handleCertInNetworkAuditDownload(props) {

    const {
        certInNetworkClientName, certInNetworkDate, certInNetworkCustomerName, certInNetworkConsultantName,
        certInNetworkLogo, certInNetworkApplicationIP, certInNetworkStartDate, certInNetworkEndDate,
        certInNetworkTestingype, certInNetworkAppDescription, certInNetworkAppEnvironment, criticalityNetwork,
        inchargeNameNetwork, inchargeEmailNetwork, inchargeDesignationNetwork, certInNetworkVulnerabilities,
        certInNetworkVulCount, certInNetworkCritical, certInNetworkHigh, certInNetworkMedium, certInNetworkLow, setCertInNetworkownloading, logout
    } = props



    setCertInNetworkownloading(true)

    const page1 = reportAppNameNetwork(certInNetworkCustomerName)
    const page12 = auditReportTableNetwork(certInNetworkDate, certInNetworkStartDate, certInNetworkEndDate)

    const page111 = TOCHeadingsNetwork

    const page21 = page2HeadingNetwork
    const page211 = documentPreparationNetwork(certInNetworkDate, certInNetworkCustomerName)
    const page212 = documentHistoryNetwork(certInNetworkDate)
    const page213 = documentDistributionNetwork(inchargeDesignationNetwork, inchargeEmailNetwork, inchargeNameNetwork, certInNetworkCustomerName)

    const page31 = introductionText1Network(certInNetworkCustomerName)
    const page312 = introductionBulletOneNetwork(certInNetworkCustomerName)
    const page313 = introductionBulletTwo
    const page314 = introductionBulletThree

    const page41 = scopeNetwork(certInNetworkApplicationIP, certInNetworkAppDescription, criticalityNetwork)

    const page42 = teamNetwork

    const page51 = auditActivities
    const page511 = auditActivities1
    const page512 = auditPoint1Network
    const page513 = auditPoint2Network
    const page514 = auditPoint3Network
    const page52 = timelines
    const page521 = timeline1Network(certInNetworkStartDate, certInNetworkEndDate)

    const page61 = accrualPhase
    const page611 = accrualPhaseText
    const page612 = accrualPhasebullet1Audit
    const page613 = accrualPhasebullet2Audit
    const pag614 = accrualPhasebullet3Audit
    const page615 = accrualPhasebullet4Audit
    const page616 = accrualPhasebullet5Audit
    const page62 = acclimatizePhase
    const page621 = acclimatizePhaseTextAudit1
    const page622 = acclimatizePhaseTextAudit2
    const page623 = acclimatizePhaseTextAudit3
    const page624 = acclimatizebullet1Audit
    const page625 = acclimatizebullet2Audit
    const page626 = acclimatizebullet3Audit
    const page63 = analysisPhase
    const page631 = analysisPhaseText
    const page64 = admittancePhase
    const page641 = admittancePhaseTextAudit
    const page65 = affirmationPhase
    const page651 = affirmationPhaseTextAudit
    const page66 = Methodology
    const page661 = methodologyAuditNote

    const page71 = FrameworkAudit
    const page711 = frameworkAuditText(certInNetworkCustomerName)
    const page72 = toolsAudit
    const page721 = toolsAuditTable

    const page81 = summaryAudit1(certInNetworkCustomerName)
    const page812 = summaryNoteAudit
    const page82 = summaryAudit2(certInNetworkCustomerName, certInNetworkTestingype)
    const page821 = summaryNoteAudit2
    const page822 = summaryNotebullet1
    const page823 = summaryNotebullet2

    const page83 = summaryGraph1
    const page831 = summaryGraph2
    const page84 = severityAuditLevelTable(certInNetworkCritical, certInNetworkHigh, certInNetworkMedium, certInNetworkLow)
    const page841 = summaryGraphchart2

    const page91 = observationAudit1
    const page911 = observationAudit2
    const page912 = observationAudit3

    const last1 = riskRatingAudit
    const last2 = riskRatingTableAudit
    const last3 = auditTools1
    const last4 = appendicesTableAudit

    const design = {
        page: {
            margin: { top: 500, right: 700, left: 750, header: 870, footer: 850 },
            // size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
            type: SectionType.CONTINUOUS,
        },
    }

    const heading1 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Introduction",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading2 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Engagement Scope",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading3 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Details of the Auditing team",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading4 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400, },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Activities and Timelines",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading5 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Audit Methodology and Criteria / Standard referred for audit",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading6 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Tools/ Software used",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading7 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Executive Summary",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading8 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Detailed Observations",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    const heading9 = new Paragraph({
        alignment: AlignmentType.CENTER,
        spacing: { before: 350, after: 400 },
        indent: { left: 600 },
        numbering: { reference: "my-crazy-numbering", level: 0 },
        tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
        children: [
            new TextRun({
                text: "Appendices",
                size: 40,
                color: "2F5496",
                font: "Arial",
                bold: true,
                italics: false,
                allCaps: false
            })
        ],
        heading: HeadingLevel.HEADING_1,
    })

    let clientImageRun;
    const MAX_WIDTH = 610;

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const getImageDimensions = (dataUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                const width = Math.min(img.width, MAX_WIDTH);
                const height = width / aspectRatio;
                resolve({ width, height });
            };
            img.onerror = (error) => reject(error);
            img.src = dataUrl;
        });
    };

    const createImageRun = async (file) => {
        try {
            const imageData = await getBase64(file);
            const dimensions = await getImageDimensions(imageData);
            return new ImageRun({
                data: imageData,
                transformation: { width: dimensions.width, height: dimensions.height },
            });
        } catch (error) {
            console.error('Error reading image data:', error);
            return null;
        }
    };

    const fetchImageAsBase64 = async (url) => {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    // overview findings
    const rows = [
        new TableRow({
            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Affected Asset i.e. IP/URL/Application etc.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Observation/Vulnerability title",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE/CWE",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT,
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New or Repeat observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),
    ];

    const getSeverityValue = (risk) => {
        switch (risk) {
            case 'Critical': return 1;
            case 'High': return 2;
            case 'Medium': return 3;
            case 'Low': return 4;
            default: return 5;
        }
    };

    const sortVulnerabilities = certInNetworkVulnerabilities.sort((a, b) => getSeverityValue(a.risk) - getSeverityValue(b.risk));

    sortVulnerabilities.forEach((vulnerability, index) => {
        rows.push(
            new TableRow({

                children: [
                    new TableCell({
                        width: { size: 600, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `${index + 1}.`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1700, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.ipAddress,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1500, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.vulnerability,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: `CWE - ${vulnerability.cwe}`,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],


                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 200, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 140, right: 140, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.risk.toUpperCase(),
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 2700, type: WidthType.DXA },
                        children: [
                            ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                new Paragraph({
                                    alignment: AlignmentType.LEFT,
                                    indent: { left: 550, right: 50, top: 50, bottom: 50 },
                                    bullet: { level: 0 },
                                    children: [
                                        new TextRun({
                                            text: bulletText.trim(),
                                            font: "Arial",
                                            size: 22,
                                            color: "000000",
                                            bold: false,
                                        }),
                                    ],
                                }),
                            )

                        ],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 1300, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: vulnerability.reference,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                    new TableCell({
                        width: { size: 800, type: WidthType.DXA },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                indent: { left: 50, right: 50, top: 50, bottom: 50 },
                                children: [
                                    new TextRun({
                                        text: "New",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        bold: false,
                                    }),
                                ],
                            }),
                        ],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ],
            }),
        )
    })

    // VulnerabilityTable
    const sortedVulnerabilities = certInNetworkVulnerabilities.sort((a, b) => getSeverityValue(a.risk) - getSeverityValue(b.risk));

    const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
        const combinedContent = [];
        for (const poc of vulnerability.poc) {
            combinedContent.push(new Paragraph({
                children: [
                    new TextRun({
                        text: poc.pocDesc,
                        size: 24,
                        italics: false,
                        bold: false
                    }),
                ],
            }));

            if (poc.files && poc.files.length > 0) {
                for (const file of poc.files) {
                    try {
                        const imageRun = await createImageRun(file);
                        combinedContent.push(new Paragraph({
                            spacing: { before: 200, after: 600 },
                            children: [imageRun],
                        }));
                    } catch (error) {
                        console.error('Error while uploading POC image:', error);
                    }
                }

            } else if (poc.pocImageURL) {
                try {
                    const pocImageData = await fetchImageAsBase64(poc.pocImageURL);
                    const dimensions = await getImageDimensions(pocImageData);
                    const imageRun = new ImageRun({
                        data: pocImageData.split(',')[1],
                        transformation: { width: dimensions.width, height: dimensions.height },
                    });
                    combinedContent.push(new Paragraph({
                        spacing: { before: 200, after: 600 },
                        children: [imageRun],
                    }));
                } catch (error) {
                    console.error('Error while fetching PoC image from URL:', error);
                }
            }
        }

        const [ipAddress, ...rest] = vulnerability.ipAddress.split(' ');
        const affectedPortText = rest.join(' ');


        return [
            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({
                heading: HeadingLevel.HEADING_1,
                tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
                indent: { left: 500 },
                spacing: { after: 300 },
                numbering: { reference: "my-crazy-numbering", level: 1 },
                children: [
                    new TextRun({
                        text: vulnerability.vulnerability,
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false
                    })
                ],
            }),

            new Table({
                width: { size: 10300, type: WidthType.DXA },
                alignment: AlignmentType.CENTER,
                borders: {
                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                },
                layout: TableLayoutType.FIXED,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({

                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Affected Asset",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),



                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 80, after: 50 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [
                                            new TextRun({
                                                text: vulnerability.ipAddress,
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false
                                            }),

                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),


                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Observation/ Vulnerability Title",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.vulnerability,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Detailed Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    ...vulnerability.description.split(/(?:•\s*|-)/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            alignment: AlignmentType.JUSTIFIED,
                                            indent: { left: 700, right: 50, top: 50, bottom: 50 },
                                            bullet: { level: 0 },
                                            children: [new TextRun({
                                                text: bulletText.trim(),
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                            ]
                                        })
                                    )
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),

                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "CVE/CWE",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: `CWE - ${vulnerability.cwe}`,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Objective",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Control Name",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Audit Requirement",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "NA",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Severity",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.risk,
                                            font: "Arial",
                                            size: 24,
                                            color: vulnerability.risk === "Critical" ? "c00000" : vulnerability.risk === "High" ? "ffc000" : vulnerability.risk === "Medium" ? "00B0F0" : vulnerability.risk === "Low" ? "92D050" : "ffffff",
                                            italics: false,
                                            bold: true,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Recommendation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        indent: { left: 100, right: 80 },
                                        spacing: { before: 100, after: 100 },
                                        children: [
                                            new TextRun({
                                                text: "It is Recommended to:",
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false
                                            }),
                                        ]
                                    }),
                                    ...vulnerability.recommendation.split(/(?:•\s*|-)/).filter(Boolean).map(bulletText =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 700, right: 100 },
                                            bullet: { level: 0 },
                                            children: [new TextRun({
                                                text: bulletText.trim(),
                                                font: "Arial",
                                                size: 24,
                                                color: "000000",
                                                italics: false,
                                                bold: false,
                                            })
                                            ]
                                        })
                                    )
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "Reference",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: vulnerability.reference.split(/\s+/).map((url) =>
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: url,
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ),
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),

                    new TableRow({
                        children: [
                            new TableCell({
                                width: { size: 2100, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New or Repeat Observation",
                                            font: "Arial",
                                            size: 24,
                                            color: "ffffff",
                                            bold: false,
                                            italics: false
                                        })
                                        ]
                                    })
                                ],
                                shading: { type: ShadingType.SOLID, color: "B4C6E7" },
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                            new TableCell({
                                width: { size: 8200, type: WidthType.DXA },
                                verticalAlign: VerticalAlign.CENTER,
                                children: [
                                    new Paragraph({
                                        spacing: { before: 150, after: 150 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: "New",
                                            font: "Arial",
                                            size: 24,
                                            color: "000000",
                                            italics: false,
                                            bold: false,
                                        })
                                        ]
                                    })
                                ],
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                },
                            }),
                        ]
                    }),
                ]
            }),

            new Paragraph({ pageBreakBefore: true }),
            new Paragraph({
                spacing: { line: 356 },
                children: [
                    new TextRun({
                        text: "Proof of Concept",
                        size: 24,
                        color: "000000",
                        font: "Arial",
                        bold: true,
                        italics: false

                    })
                ],
            }),

            ...combinedContent
        ]
    })
    const docSectionsResolved = await Promise.all(docSections);


    const doc = new Document({
        creator: "manjesh",
        features: { updateFields: true },
        numbering: {
            config: [
                {
                    reference: "my-crazy-numbering",
                    levels: [
                        {
                            level: 0,
                            format: LevelFormat.DECIMAL,
                            text: "%1.",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                run: {
                                    size: 40,
                                    bold: true,
                                    color: "2F5496",
                                },
                            },
                        },
                        {
                            level: 1,
                            format: LevelFormat.DECIMAL,
                            text: "8.%2",
                            alignment: AlignmentType.RIGHT,
                            style: {
                                paragraph: {
                                    indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                },
                                text: { color: "000000", bold: true, size: 24, font: "Arial" },
                                run: {
                                    size: 24,
                                    bold: true,
                                    color: "000000",
                                    font: "Arial"
                                },
                            },
                        },

                    ]
                }
            ]
        },
        styles: {
            default: {

                document: {
                    run: {
                        font: "Arial",
                        bold: true,
                        size: 24,
                        color: "000000",
                    },
                },
                heading1: {
                    run: {

                        font: "Arial",
                        bold: true,
                        italics: false,
                        allCaps: false
                    },
                    paragraph: { spacing: { line: 276 } },
                },
            },
        },
        sections: [
            {
                properties: { ...design },
                headers: {
                    default: new Header({
                        children: [
                            new Table({
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                alignment: AlignmentType.RIGHT,
                                borders: {
                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 100, type: WidthType.PERCENTAGE },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "<Confidential>",
                                                                size: 24,
                                                                font: "Arial",
                                                                color: '000000',
                                                                bold: false
                                                            })
                                                        ]
                                                    })],
                                                borders: {
                                                    top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    bottom: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Table({
                                margin: { top: 600 },
                                width: { size: 100, type: WidthType.PERCENTAGE },
                                borders: {
                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                },
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: { size: 5, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Page",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                            new TableCell({
                                                width: { size: 18, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        alignment: AlignmentType.LEFT,
                                                        children: [
                                                            new TextRun({
                                                                children: [PageNumber.CURRENT],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                text: " of ",
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),

                                                            new TextRun({
                                                                children: [PageNumber.TOTAL_PAGES],
                                                                italics: false,
                                                                font: "Calibri",
                                                                size: 24,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),

                                            new TableCell({
                                                width: { size: 77, type: WidthType.PERCENTAGE },
                                                spacing: { before: 100 },
                                                children: [
                                                    new Paragraph({
                                                        indent: { right: 200 },
                                                        alignment: AlignmentType.RIGHT,
                                                        children: [
                                                            new TextRun({
                                                                text: "Cert-In Audit report format: Version 1.0",
                                                                font: "Calibri",
                                                                size: 24,
                                                                italics: false,
                                                                color: "002060",
                                                                bold: false
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                                borders: {
                                                    top: { style: BorderStyle.THICK_THIN_MEDIUM_GAP, size: 3 * 8, color: "D00014" },
                                                    bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                },
                                            }),
                                        ]
                                    })
                                ]

                            })
                        ]
                    })
                },
                children: [page1, page12],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [page21, page211, new Paragraph({ spacing: { after: 600 }, }), page212, new Paragraph({ spacing: { after: 600 } }), page213],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [
                    page111,
                    new Table({
                        width: { size: 100, type: WidthType.PERCENTAGE },
                        layout: TableLayoutType.FIXED,
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        alignment: AlignmentType.LEFT,
                        rows: [
                            new TableRow({

                                children: [
                                    new TableCell({
                                        width: { size: 100, type: WidthType.PERCENTAGE },
                                        children: [
                                            new Paragraph({
                                                children: [
                                                    new TableOfContents("Table of Content", {
                                                        hyperlink: true,
                                                        headingStyleRange: "1-5",
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading1, page31, page312, page313, page314],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading2, page41],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading3, page42],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading4, page51, page511, page512, page513, page514, page52, page521],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading5, page61, page611, page612, page613, pag614, page615, page616, page62, page621, page622, page623, page624, page625, page626, page63, page631, page64, page641, page65, page651, page66, page661],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading6, page71, page711, page72, page721],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading7, page81, page812, page82, page821, page822, page823],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [page83, page831, page84, page841],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [new Paragraph({}),
                new Table({
                    width: { size: 10335, type: WidthType.DXA },
                    layout: TableLayoutType.FIXED,
                    alignment: AlignmentType.CENTER,

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                    },
                    rows: rows
                })
                ],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading8, page91, page911, page912],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [...docSectionsResolved.flat()],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [heading9, last1, last2],
                pageBreakBefore: true,
            },

            {
                properties: { ...design },
                children: [last3, last4],
                pageBreakBefore: true,
            },

        ]
    })

    try {
        const response = await fetch(`${url}/reportdownload`, {
            method: 'POST',
            credentials: 'include'
        })
        if (response.ok) {
            Packer.toBlob(doc).then(blob => {
                saveAs(blob, `Internal Network Audit Report of ${certInNetworkCustomerName} .docx`);
            });
            setCertInNetworkownloading(false)
            return
        }
        if (response.status === 440) {
            logout()
            toast.error("User logout due to inactivity", {
              position: 'top-right',
              autoClose: 2500,
              pauseOnHover: false,
            });
            return
          }
    } catch (error) {
        console.log(error)
        setCertInNetworkownloading(false)
    }


}
